// ----------------------------------------------------------------------
// <copyright file="Izenda.EmbededReportUtils.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  const { map, isBoolean, set, reduce, compact, get, getOr } = require('lodash/fp');
  module.exports = {
    buildPromiseFetcher: function(reportPart, reportPartDefinitionFetcher, reportDefinitionFetcher, increaseView) {
      var listEmbededReportPartPromise = Promise.all(
        map(function(reportPartId) {
          return reportPartDefinitionFetcher(reportPartId).catch(function(error) {
            return null;
          });
        }, reportPart.embededInfo.reportPartIds)
      );
      var listEmbededReportPromise = Promise.all(
        map(function(reportId) {
          return reportDefinitionFetcher(reportId, undefined, undefined, increaseView)
            .then(function(data) {
              if (!data || (isBoolean(get('success', data)) && !data.success)) {
                return null;
              }
              return data;
            })
            .catch(function(error) {
              return null;
            });
        }, reportPart.embededInfo.reportIds)
      );

      return Promise.join(listEmbededReportPartPromise, listEmbededReportPromise, function(
        listEmbededReportPartDef,
        listEmbededReportDef
      ) {
        return {
          reportParts: reduce(
            function(acc, item) {
              return set(item.id, item, acc);
            },
            {},
            compact(listEmbededReportPartDef)
          ),
          reports: reduce(
            function(acc, item) {
              var report = item.report;
              return set(report.id, report.reportPart, acc);
            },
            {},
            compact(listEmbededReportDef)
          )
        };
      });
    },
    readEmbededReportDef: function(reportPart, fieldInfo) {
      var listEmbededReportPart = [];

      if (fieldInfo.embededInfo.reportId) {
        listEmbededReportPart = getOr([], 'embedReportDef.reports.' + fieldInfo.embededInfo.reportId, reportPart);
      } else {
        listEmbededReportPart = compact(
          map(function(id) {
            return get('embedReportDef.reportParts.' + id, reportPart);
          }, fieldInfo.embededInfo.reportPartIds)
        );
      }

      return listEmbededReportPart;
    }
  };
})();



// WEBPACK FOOTER //
// ./ui/share/utils/Izenda.EmbededReportUtils.js